import * as React from 'react';
import { FontSizeProps, fontSize } from 'styled-system';
import styled from 'styled-components';
import { media, themeGet } from '@packages/ui';

const CarouselTitleStyled = styled.div.attrs({ 'data-testid': 'carousel-title' })<FontSizeProps>`
  font-family: ${themeGet.fonts('brand')};
  font-weight: ${themeGet.fontWeight('semibold')};
  color: ${themeGet.colors('sandDune')};
  ${fontSize};
  padding-bottom: ${themeGet.space(2)};
  position: relative;

  text-align: center;
  padding: auto;
  span {
    position: relative;
    box-shadow: 0px 8px 0px 8px white;
  }

  display: flex;
  justify-content: center;

  ${media.from.md`
    padding-bottom: ${themeGet.space(1)};
  `};

  ${media.from.xl`
    padding-bottom: ${themeGet.space(2)};
  `};
`;

export const CarouselHeader: React.FC = ({ children }) => {
  return (
    <CarouselTitleStyled fontSize={[7]}>
      <span>{children}</span>
    </CarouselTitleStyled>
  );
};
